<template>
  <div>
    <div v-if="YazdirText" v-html="YazdirText" class="yazdirbody"></div>
    <div v-if="AvukatYazdir" class="yazdirbody">
      <div class="makbuz">
        <h6 class="text-center">AVUKAT BİLGİ DÖKÜMÜ</h6>
        <hr>
        <div class="Detay">
          <table class="table">
            <thead>
            <tr>
              <th>Son Ödeme Tarihi</th>
              <th>Borç Türü</th>
              <th>Açıklama</th>
              <th class="text-right">Tutar</th>
              <th class="text-right">Zam</th>
              <th class="text-right">Ödenen</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="Tahakkuk in Secilen">
              <td>{{ Tahakkuk.tTarihi }}</td>
              <td>{{ Tahakkuk.Kategori }}</td>
              <td>{{ Tahakkuk.Aciklama }}</td>
              <td class="text-right">{{ Tahakkuk.TutarText }}</td>
              <td class="text-right">{{ Tahakkuk.ZamTutarText }}</td>
              <td class="text-right">{{ Tahakkuk.OdenecekText }}</td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3" class="text-right">ALT TOPLAM</th>
              <th class="text-right">{{ st.ToplamTutar }}</th>
              <th class="text-right">{{ st.ToplamZam }}</th>
              <th class="text-right">{{ st.ToplamOdenecek }}</th>
            </tr>
            </tfoot>
          </table>
        </div>
        <div class="Bilgi">
          <table class="table">
            <thead>
            <tr>
              <th colspan="2" class="text-center">MÜLK BİLGİ</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(v,k) in MulkBilgi">
              <td>{{ k }}</td>
              <td class="text-right">{{ v }}</td>
            </tr>
            </tbody>
          </table>
          <table class="table">
            <thead>
            <tr>
              <th colspan="2" class="text-center">BORÇLU BİLGİ</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="b in Borclu.Detay">
              <td>{{ b.Baslik }}</td>
              <td class="text-right">{{ b.Bilgi }}</td>
            </tr>
            </tbody>
          </table>
          <table v-if="Sahip" class="table">
            <thead>
            <tr>
              <th colspan="2" class="text-center">MÜLK SAHİBİ BİLGİ</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="b in Sahip.Detay">
              <td>{{ b.Baslik }}</td>
              <td class="text-right">{{ b.Bilgi }}</td>
            </tr>
            </tbody>
          </table>


        </div>
      </div>
    </div>
    <div class="sayfahead yazdirma">
      <h1>{{ SayfaAdi }}</h1>
      <el-button-group class="float-right">
        <router-link v-if="this.$store.getters.Yetki.yonetim>0"
                     class="el-button YeniBtn el-button--primary el-button--small" :to="'/yonetim/kisi/'+Kisi_id">
          Kişi Ekranı
        </router-link>
        <router-link v-if="this.$store.getters.Yetki.vezne>0"
                     class="el-button YeniBtn el-button--success el-button--small" :to="'/vezne/tahsilat/'+Kisi_id">
          Tahsilat Ekranı
        </router-link>
      </el-button-group>
    </div>
    <div class="icerik yazdirma">
      <el-row :gutter="24">
        <Yukleniyor :data="lo"></Yukleniyor>
        <el-col :span="4">
          <IcraListe @Kisi_id="KisiGetir($event)" :Yenile="Yenile"></IcraListe>
        </el-col>
        <el-col :span="20">
          <el-row :gutter="24">
            <el-col :span="19">
              <el-tabs>
                <el-tab-pane :lazy=true>
                  <span slot="label"><el-badge :value="TahakkukAdet" class="m-badge">Tahakkuklar</el-badge></span>
                  <el-table
                    v-if="Liste"
                    ref="multipleTable"
                    class="table-xs"
                    :data="Liste"
                    @selection-change="handleSelectionChange"
                    width="100%"
                    :height="Height"
                    show-summary
                    :summary-method="TableFooter"
                    :row-class-name="TableClass"
                  >
                    <el-table-column
                      type="selection"
                      width="50"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="tTarihi"
                      label="Borçlanma Tarihi"
                      width="100">
                    </el-table-column>
                    <el-table-column
                      prop="sTarihi"
                      label="Son Ödeme Tarihi"
                      width="100">
                    </el-table-column>
                    <el-table-column
                      prop="Kategori"
                      label="Kategori"
                      width="100">
                    </el-table-column>
                    <el-table-column
                      prop="Aciklama"
                      label="Açıklama"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="Zam"
                      label="Zam Bilgi"
                      width="100">
                    </el-table-column>
                    <el-table-column
                      prop="TutarText"
                      label="Tutar"
                      width="90">
                    </el-table-column>
                    <el-table-column
                      prop="ZamTutarText"
                      label="Zam"
                      width="90">
                    </el-table-column>
                    <el-table-column
                      prop="OdenecekText"
                      label="Ödenecek"
                      width="90">
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
                <el-tab-pane :lazy=true>
                  <span slot="label"><el-badge :value="IcraDosyaAdet" class="m-badge">İcra Dosyaları</el-badge></span>
                  <el-row :gutter="24">
                    <el-col :span="6" v-for="Dosya in IcraDosya">
                      <div class="matbuu icra">
                        <i class="el-icon-document-copy"></i>
                        <p><small>Avukat</small> {{ Dosya.Bilgi.Unvan }}</p>
                        <p v-if="Dosya.Bilgi.dNo"><small>Dosya No</small> {{ Dosya.Bilgi.dNo }}</p>
                        <p><small>İcra Tarih</small> {{ Dosya.Bilgi.iTarihText }}</p>
                        <p><small>Anapara</small> {{ Dosya.Bilgi.AltTutar }}</p>
                        <p><small>Zam</small> {{ Dosya.Bilgi.AltZam }}</p>
                        <p><small>Ödenecek</small> {{ Dosya.Bilgi.AltToplam }}</p>
                        <el-button-group class="mt-2">
                          <el-button
                            size="mini"
                            type="primary"
                            icon="feather-search"
                            @click="IcraDosyaDetay(Dosya)">
                            Dosya Detay
                          </el-button>
                        </el-button-group>
                      </div>
                    </el-col>
                  </el-row>
                </el-tab-pane>
              </el-tabs>
            </el-col>
            <el-col :span="5">
              <div v-if="Secilen.length" class="SecimKutu mb-4">
                <el-row :gutter="24">
                  <el-col :span="6">
                    <div class="Secilen text-info">
                      <small>Seçilen</small>
                      <p>{{ Secilen.length }}</p>
                    </div>
                  </el-col>
                  <el-col :span="18">
                    <div class="BorcBilgi">
                      <div class="Zam text-danger">
                        <p><small>Zam</small> {{ st.ToplamZam }}</p>
                      </div>
                      <div class="Anapara text-success">
                        <p><small>Anapara</small> {{ st.ToplamTutar }}</p>
                      </div>
                      <div class="Odenecek text-primary">
                        <small>Dosya Tutarı</small>
                        <p>{{ st.ToplamOdenecek }}</p>
                      </div>
                    </div>
                  </el-col>

                  <el-col :span="24">
                    <el-button class="btn-block" @click="DosyaOlustur" size="small" type="danger">Dosya Oluştur
                    </el-button>
                    <a class="text-danger d-block text-center mt-2" @click="IhtarYazdir()"
                       style="font-size: 12px"><i
                      class="feather-printer"></i> İhtar Metni Yazdır</a>
                    <a class="text-primary d-block text-center mt-2" @click="AvukatBilgiYazdir()"
                       style="font-size: 12px"><i
                      class="feather-printer"></i> Avukat Dökümü Yazdır</a>
                  </el-col>
                </el-row>
              </div>
              <div class="BlokSabit scrollkaydir" :style="Secilen.length>0?'height: 53vh':'height: 85vh'">
                <BilgiKutu :data="Borclu" v-if="Borclu"></BilgiKutu>
                <BilgiKutu :data="Sahip" v-if="Sahip"></BilgiKutu>
                <Notlar v-if="Liste" :data="Notlar"></Notlar>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <IcraDosyaOlustur v-if="ModalOlayi" :Bina_id="Bina_id" :data="Secilen" :Bilgi="Bilgi" :ModalOlayi="ModalOlayi"
                      @ModalOlayi="ModalKapat"></IcraDosyaOlustur>


  </div>
</template>

<script>
import IcraListe from "../../../components/Pack/Icra/IcraListe";
import Notlar from "../../../components/Pack/Genel/Notlar";
import BilgiKutu from "../../../components/Pack/Genel/BilgiKutu";
import IcraDosyaOlustur from "../../../components/Pack/Icra/IcraDosyaOlustur";
import Yukleniyor from "../../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor, IcraDosyaOlustur, BilgiKutu, Notlar, IcraListe},
  props: ["Kisi_id"],
  data() {
    return {
      Bina_id: null,
      lo: false,
      YazdirBilgi: null,
      Height: 0,
      ModalOlayi: false,
      IcraModalOlayi: false,
      IhtarModalOlayi: false,
      Yenile: false,
      SayfaAdi: 'İcralık Dosyalar',
      Notlar: {},
      Liste: [],
      IcraDosya: [],
      Secilen: [],
      Kaydet: false,
      st: {
        ToplamTutar: null,
        ToplamZam: null,
        ToplamOdenecek: null
      },
      MulkBilgi: null,
      Borclu: null,
      Bilgi: null,
      Sahip: null,
      TahakkukAdet: null,
      IcraDosyaAdet: null,
      AltToplam: [],
      YazdirText: null,
      AvukatYazdir: false
    }
  },
  methods: {
    TableClass({row}) {
      return row.Class
    },
    ModalKapat() {
      this.SayfaYukle();
      this.Yenile = true;
    },
    IcraDosyaDetay(val) {
      this.Bilgi = val.Bilgi;
      this.Secilen = val.Secilen;
      this.ModalOlayi = true;
    },
    TableFooter() {
      const sums = [];
      sums[6] = this.AltToplam.AltTutar;
      sums[7] = this.AltToplam.AltZam;
      sums[8] = this.AltToplam.AltToplam;
      return sums;
    },
    AvukatBilgiYazdir() {
      this.YazdirText = null;
      this.AvukatYazdir = true;
      this.lo = true;
      setTimeout(() => {
        this.lo = false;
        window.print();
      }, 1000);

    },
    IhtarYazdir() {
      var Form = {
        data: this.st,
        Borclu: this.YazdirBilgi.Borclu,
        Secilen: this.Secilen
      };
      this.YazdirText = null;
      this.AvukatYazdir = false;
      this.lo = true;
      this.$store.dispatch("Post", {Form, path: 'icra/ihtar/'})
        .then(response => {

          if (response.Durum == "OK") {
            this.YazdirText = response.Text;
            setTimeout(() => {
              window.print();
              this.lo = false;
            }, 1000);

          } else {
            this.$message.error(response.Mesaj);
          }
        });
    },
    handleSelectionChange(val) {
      this.ModalOlayi = false;
      this.Secilen = val;
      this.Kaydet = true;
      this.st.ToplamTutar = this.Secilen.reduce((acc, item) => acc + Number(item.Tutar), 0).toFixed(2);
      this.st.ToplamZam = this.Secilen.reduce((acc, item) => acc + Number(item.ZamTutar), 0).toFixed(2);
      this.st.ToplamOdenecek = (Number(this.st.ToplamTutar) + Number(this.st.ToplamZam)).toFixed(2);

    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
      this.Kaydet = true
    },
    DosyaOlustur() {
      this.Bilgi = null;
      this.ModalOlayi = true
    },
    SayfaYukle() {
      this.TahakkukAdet = null;
      this.IcraDosyaAdet = null;
      this.Liste = null;
      this.IcraDosya = null;
      this.ModalOlayi = false;
      this.Secilen = [];
      this.Borclu = null;
      this.MulkBilgi = null;
      this.Sahip = null;
      this.YazdirBilgi = null;
      this.Height = window.innerHeight - 145
      this.Yenile = false;
      this.lo = true;
      this.$store.dispatch("Get", {path: 'icra/dosya/dosya/' + this.Kisi_id})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.YazdirBilgi = response;
            this.Liste = response.Tahakkuk;
            this.MulkBilgi = response.MulkBilgi;
            this.IcraDosya = response.IcraDosya;
            this.AltToplam = response.AltToplam;
            if (this.Liste) this.TahakkukAdet = this.Liste.length;
            if (this.IcraDosya) this.IcraDosyaAdet = this.IcraDosya.length;
            this.Bina_id = response.Borclu.Bina_id;
            this.Borclu = {
              Baslik: 'Borçlu Bilgi',
              Detay: [
                {Baslik: 'Ad Soyad', Bilgi: response.Borclu.AdSoyad, Ikon: 'flaticon-background'},
                {Baslik: 'Telefon', Bilgi: response.Borclu.Telefon, Ikon: 'flaticon-background'},
                {Baslik: 'TC Kimlik', Bilgi: response.Borclu.vNo, Ikon: 'flaticon-background'},
                {
                  Baslik: 'Giriş Tarihi',
                  Bilgi: response.Borclu.gTarihi,
                  Ikon: 'flaticon-background'
                },
                {
                  Baslik: 'Çıkış Tarihi',
                  Bilgi: response.Borclu.cTarihi,
                  Ikon: 'flaticon-background'
                },
              ]
            };
            if (response.Sahip) {
              this.Sahip = {
                Baslik: 'Sahip Bilgi',
                Detay: [
                  {
                    Baslik: 'Ad Soyad',
                    Bilgi: response.Sahip.AdSoyad,
                    Ikon: 'flaticon-background'
                  },
                  {Baslik: 'Telefon', Bilgi: response.Sahip.Telefon, Ikon: 'flaticon-background'},
                  {Baslik: 'TC Kimlik', Bilgi: response.Sahip.vNo, Ikon: 'flaticon-background'},
                  {
                    Baslik: 'Giriş Tarihi',
                    Bilgi: response.Sahip.gTarihi,
                    Ikon: 'flaticon-background'
                  },
                  {
                    Baslik: 'Çıkış Tarihi',
                    Bilgi: response.Sahip.cTarihi,
                    Ikon: 'flaticon-background'
                  },
                ]
              }
            }


          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });

      this.Notlar = {
        Modul: 'Kisi',
        Modul_id: this.Kisi_id
      }
    }
  },
  created() {
    this.SayfaYukle();
  },
  computed: {
    KisiSecim() {
      return this.Kisi_id
    },
    /*Secilen() {
        return this.Secilen
    }*/
  },
  watch: {
    KisiSecim() {
      this.SayfaYukle();
      //console.log(this.Form.Tutar);
    },
    /*Secilen() {
            if (this.Secilen && this.Secilen.length) this.Kaydet = true; else this.Kaydet = false;
        }*/
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Icra/dosya/detay.vue